import React from "react";
import Button from "./Button";
import Tooltip from "react-tooltip";
import { InformationCircleIcon, PrinterIcon } from "@heroicons/react/24/solid";

const DashboardCard = ({ image, text, count, hasAccess }) => {
  var message =
    "Contact your System Administrator to secure access to this module.";
  return (
    <>
      <span className="flex items-center p-1 gap-x-2">
        {image}
        <div className="uppercase font-medium text-xs1">{text}</div>
      </span>
      <div className="text-left hover:text-white items-center cursor-pointer h-1/2">
        <div className="">
          {hasAccess ? (
            <div className="text-right text-md 2xl:text-2xl lg:text-lg md:text-lg font-bold ">
              {count}
            </div>
          ) : (
            <div className=" flex justify-end pt-1">
              <Tooltip
                id="Dashboard"
                place="top"
                effect="solid"
                type="info"
                border={false}
                arrowColor="#3a3b3c"
                // borderColor="#0078d7"
                backgroundColor="#3a3b3c"
                textColor="white"
              />
              <InformationCircleIcon
                data-tip={
                  "Contact your System Administrator to secure access to this module."
                }
                data-for="Dashboard"
                className=" h-6 w-6 mr-1 mb-1 text-primary hover:text-white"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardCard;
